import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { CurrentUserState } from '../../../../../core/store/current-user/current-user.state';
import { AsyncPipe } from '@angular/common';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { map } from 'rxjs';
import { Subscription } from '../../../../../core/store/current-user/models/CurrentUserUIModel';
import { LearningPlanInstancesResponseDTO } from '../../../learning-plan/models/LearningPlanDTO';
import { CourseInstancesOverviewComponent } from '../course-instances-overview/course-instances-overview.component';
import { LearningPlanCourseInstanceOverviewComponent } from '../learning-plan-course-instance-overview/learning-plan-course-instance-overview.component';
import { PrimaryButtonComponent } from '../../../../../shared/components/primary-button/primary-button.component';
import { AnalyticsService } from '../../../../../core/services/analytics/analytics.service';

@Component({
  selector: 'app-dashboard-welcome',
  imports: [
    AsyncPipe,
    TranslocoDirective,
    CourseInstancesOverviewComponent,
    LearningPlanCourseInstanceOverviewComponent,
    PrimaryButtonComponent,
  ],
  templateUrl: './dashboard-welcome.component.html',
  styleUrl: './dashboard-welcome.component.css',
})
export class DashboardWelcomeComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly translocoService = inject(TranslocoService);
  private readonly analyticsService = inject(AnalyticsService);

  subscription = input<Subscription | null>(null);
  learningPlans = input<LearningPlanInstancesResponseDTO | null>(null);

  userDetails$ = this.store.select(CurrentUserState.userDetails);

  dashboardImageSrc$ = this.translocoService.langChanges$.pipe(
    map((lang) => `assets/dashboard-welcome-img-${lang}.png`),
  );

  navigateToCourseLibrary(): void {
    this.analyticsService.track('course_library_access');
    void this.router.navigate(['portal/courseLibrary']);
  }
}
